import { Grid, InputLabel, Chip, IconButton, Checkbox, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { CloseIcon } from '@room-match/shared-ui-components';
import { id } from 'date-fns/locale';
import { FormikProps } from 'formik';
import { CustomTypograhy } from 'pages/Representatives/components/Typograhy';
import { useEffect, useRef, useState } from 'react';
import { COLORS } from 'shared/constants/COLORS';
import { DriverClass } from 'shared/enums/DriversClass';
import { IAccountUpdatePayload } from 'shared/interfaces/IAccount';

const DriversClass: DriverClass[] = Object.values(DriverClass);

interface DriversLicenseProps {
  form: FormikProps<IAccountUpdatePayload>;
}

const DriversLicense = ({ form }: DriversLicenseProps) => {
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    const node = driverLicenseRef.current;
    if (!node) return;

    const updateWidth = () => {
      setWidth(node.offsetWidth);
    };

    updateWidth(); // initial value

    const resizeObserver = new ResizeObserver(updateWidth);
    resizeObserver.observe(node);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const driverLicenseRef = useRef<HTMLDivElement | null>(null);
  return (
    <div style={{ width: '100%' }} ref={driverLicenseRef}>
      <InputLabel>Driver's License Class</InputLabel>
      <Autocomplete
        onChange={(_, value) => form.setFieldValue('drivers_license_types', value)}
        multiple
        value={(form && form?.values.drivers_license_types) || []}
        options={DriversClass}
        disableCloseOnSelect
        getOptionLabel={(option) => option}
        getOptionSelected={(option, value) => option === value}
        renderTags={(value, getTagProps) => {
          const displayedTags = value.slice(
            0,
            width > 650 ? 5 : width > 590 ? 4 : width > 490 ? 3 : width > 420 ? 2 : width > 272 ? 1 : 0,
          );
          const moreCount = value.length - displayedTags.length;

          return (
            <>
              {displayedTags.map((option, index) => {
                const title = option.split(' - ');
                return (
                  <Chip
                    label={title[0]}
                    style={{ fontSize: 12 }}
                    {...getTagProps({ index })}
                    deleteIcon={
                      <IconButton style={{ fontSize: 9, padding: 0, margin: 0 }}>
                        <CloseIcon fontSize={'inherit'} />
                      </IconButton>
                    }
                  />
                );
              })}
              {moreCount > 0 && (
                <Chip
                  label={moreCount === 5 ? 'All' : `+${moreCount} more`}
                  style={{ fontSize: 12, width: 'fit-content' }}
                />
              )}
            </>
          );
        }}
        renderOption={(option, { selected }) => {
          const title = option.split(' - ');
          return (
            <li style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <Checkbox checked={selected} style={{ color: COLORS.CUSTOMGREY_DARK_DARK, padding: 0, margin: 0 }} />
              <div>
                <CustomTypograhy style={{ fontSize: 12 }}>{title[0]}</CustomTypograhy>
                <CustomTypograhy style={{ fontSize: 10 }}>{title[1]}</CustomTypograhy>
              </div>
            </li>
          );
        }}
        renderInput={(params) => <TextField {...params} variant="outlined" />}
      />
    </div>
  );
};

export default DriversLicense;
